import { styled } from '@mui/material/styles';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SpellcheckRoundedIcon from '@mui/icons-material/SpellcheckRounded';
import ShortTextRoundedIcon from '@mui/icons-material/ShortTextRounded';
import NotesRoundedIcon from '@mui/icons-material/NotesRounded';

export const InputBlurWrapper = styled('div')(() => ({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 20px)',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    pointerEvents: 'none',
    top: 2,
    left: 2,
    '& .MuiCircularProgress-root': {
        color: 'rgba(0, 0, 0, 0.38) !important',
    },
}));

const styledIcon = IconComponent =>
    styled(IconComponent)({
        width: 18,
        height: 18,
        marginRight: 8,
        color: 'var(--text-secondary)',
    });

export const StyledImproveIcon = styledIcon(AutoAwesomeRoundedIcon);
export const StyledTranslateIcon = styledIcon(TranslateRoundedIcon);
export const StyledMakeShorterIcon = styledIcon(ShortTextRoundedIcon);
export const StyledMakeLongerIcon = styledIcon(NotesRoundedIcon);
export const StyledMicrophoneIcon = styledIcon(RecordVoiceOverRoundedIcon);
export const StyledPanIcon = styledIcon(SpellcheckRoundedIcon);
